import { CellContent } from '@/modules/vip/ComparisonSection/components/CellContent';
import {
  ScSectionTitle,
  ScValueCell,
} from '@/modules/vip/ComparisonSection/components/ComparisonSlider/styled';
import type { IComparisonUISection } from '@/modules/vip/ComparisonSection/types';

interface ISlideSectionProps {
  colIndex: number;
  section: IComparisonUISection;
}

export const SlideSection = ({ colIndex, section }: ISlideSectionProps) => (
  <>
    <ScSectionTitle aria-hidden style={{ visibility: 'hidden' }}>
      {section.title}
    </ScSectionTitle>
    {section.rows.map((row) => (
      <ScValueCell key={row.id}>
        <CellContent cell={row.cells[colIndex]} />
      </ScValueCell>
    ))}
  </>
);
